<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
  <path fill="#fff" d="M20 32a5 5 0 11-10 0 5 5 0 0110 0zM42 32a5 5 0 11-10 0 5 5 0 0110 0z"/>
  <path fill="#000" d="M18 9h22l7 13v11h-5.1a5 5 0 10-9.8 0H19.9a5 5 0 10-9.848-.279c-.023.098-.04.191-.052.279H1V22l10-3 7-10z"/>
  <path stroke="#000" stroke-width="2" d="M20 32a5 5 0 11-10 0 5 5 0 0110 0zM42 32a5 5 0 11-10 0 5 5 0 0110 0z"/>
</svg>
